import styled from "styled-components";
import { ButtonCommon } from "../../../Layout/styled";

export const ModalClaimContainer = styled.div`
  .point {
    color: var(--New, #e84142);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 16.32px; /* 116.571% */
    border-radius: 6px;
    background: #000;
    position: relative;
    padding-left: 20px;
    width: 102px;
    height: 41px;
    margin: 0 auto 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:before {
      position: absolute;
      content: "";
      top: 50%;
      margin-top: -7px;
      left: 15px;
      background: url("/assets/images/leaderboard/icn_point.svg") center /
        contain no-repeat;
      width: 16px;
      height: 16px;
    }
  }
  .title-modal {
    text-align: center;
    font-family: Dirtyline;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 100% */
    text-transform: lowercase;
    background: linear-gradient(
      90deg,
      #ff3556 0.08%,
      #ff63a1 25.04%,
      #ffdb87 50%,
      #fff 99.92%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 8px;
  }
  .des {
    color: rgba(255, 255, 255, 0.75);
    text-align: center;
    font-family: Syne;
    font-size: 12.681px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%; /* 15.851px */
    margin-bottom: 24px;
  }
  ${ButtonCommon} {
    width: 105px;
    margin: 0 auto;
    font-size: 12px;
    font-weight: 500;
    padding-top: 13px;
    padding-bottom: 11px;
  }
`;
